import { Campground_Data, Trip_Cluster_v2 } from "../../util/tripPlanner_types";
import { get_favoritedCamps, getTripDirections, getTripHTML, send_addStayToStop } from "../api_utils";
import { clear_highlightedMarker, clearLayer, enlargeIcon, getStayMarker, shrinkIcon } from "../map/helper_functions";
import { display_potential_stay_pins, displayStayPins, remove_stay_pin } from "../map/map_displays";
import { display_route, display_trip, display_trip_html, init_remWishes_listener } from "../tripPlanner_scripts";
import { init_stay_hover_listener, stopPopout_display_added_stays } from "../ui_utils";
import { add_stay_to_stop } from "../update_trip_utils";
import { get_stop_from_stopID, handle_auto_lock, inc_interaction_counter } from "../util/helper_functions";
import { init_stopPopout_ui_listeners } from "./generalUI";

export function init_staySelectionListeners() {

    $("[add-stay-to-stop]").off("click");
    $("[add-stay-to-stop]").on("click", async function(event) {
        event.stopImmediatePropagation();
        //in case user clicked from expanded camp card
        $(".modal").modal("hide");

        const stopID:string = this.getAttribute("stopID");
        const campID:number = parseInt($(this).attr("campID"));

        let stopData:{stop:Trip_Cluster_v2,legIndex:number,stopIndex:number}|null = get_stop_from_stopID(stopID,window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        let stop:Trip_Cluster_v2 = stopData.stop;
        let legIndex:number = stopData.legIndex;
        let stopIndex:number = stopData.stopIndex;


        const newStay:Campground_Data|undefined = add_stay_to_stop(stop, campID);

        if (newStay === undefined) return;

        if (!stopData.stop.fromUserQuery) {
            if (! stop.fromUserQuery) {
                stopData = await handle_auto_lock(stopData);
                if (stopData == null) return;
                stop = stopData.stop;
                legIndex = stopData.legIndex;
                stopIndex = stopData.stopIndex;
            };
        };

        $("#stopPopout").find("#stayList").find(`#${campID}`).remove();
        stopPopout_display_added_stays(stop, window.tripPlannerCurrentTrip.filters.dist_unit);

        send_addStayToStop(legIndex, stopIndex, campID, newStay.s_date, newStay.numNights);

        inc_interaction_counter();

        remove_stay_pin(campID);
        clearLayer(window.stayMarkerLayer);
        displayStayPins(window.tripPlannerCurrentTrip);
        init_stay_hover_listener();
        clear_highlightedMarker();
        if (parseInt($("#ol_map_popup_card").attr("campID")) == campID) {
            $("#ol_map_popup_card").find("[add-stay-to-stop]").remove();
        };
        if (parseInt($("#map-stay-mobile").find(".card").attr("campID")) == campID) {
            $("#map-stay-mobile").find(".card").find("[add-stay-to-stop]").remove();
        };

        $("#stays").scrollTop(0);

        if (!Number.isNaN(newStay.dist) && newStay.dist >= 20) {
            $("#updateStopLoc").attr("stopID", stop.stopID);
            $("#updateStopLoc").attr("campID", newStay.camp.campID);
            $("#updateStopLoc-stopName").text(`This campground is 20 miles or more from ${stop.clusterTitle}`);
            $("#updateStopLocModal").modal("show");
        };

        getTripHTML(window.tripPlannerCurrentTrip).then(tripHTML => {
            window.tripPlannerCurrentTrip.stopListHTML = tripHTML;
            display_trip_html(window.tripPlannerCurrentTrip, false);

            $(`a[href="#stays-${stopID}"]`).tab("show");
            $(`a[href="#stays-${stopID}"]`).trigger("shown.bs.tab");
        }).catch(e => {
            console.error(e);
        });
        document.dispatchEvent(new CustomEvent("directionsUpdateNeeded"));
    });

    $("[unaddedstay]").off("mouseenter");
    $("[unaddedstay]").on("mouseenter", function() {
        const campID:number = parseInt(this.getAttribute("id"));
        const stayMarker = getStayMarker(campID);
        // if (stayMarker != null) highlightMarker(stayMarker);
        if (stayMarker != null) enlargeIcon(stayMarker, null);
    });
    $("[unaddedstay]").off("mouseleave");
    // $("[unaddedstay]").on("mouseleave", clear_highlightedMarker);
    $("[unaddedstay]").on("mouseleave", function() {
        const campID:number = parseInt(this.getAttribute("id"));
        const stayMarker = getStayMarker(campID);
        if (stayMarker != null) shrinkIcon(stayMarker, null);
    });
};

export function init_customEventListeners() {
    $("#stopPopout").on("element.shown", () => {
        init_stopPopout_ui_listeners();
    });

    document.getElementById("stopPopout").addEventListener("stays.displayed", init_staySelectionListeners);

    document.getElementById("stopPopout").addEventListener("wishes.displayed", () => {
        init_remWishes_listener();
    });

    document.addEventListener("trip.updated", function(event:CustomEvent) {
        let changeMapZoom:boolean;
        if (event.detail != null && event.detail.zoom != undefined) {
            changeMapZoom = event.detail.zoom;
        } else {
            changeMapZoom = true;
        }
        display_trip(window.tripPlannerCurrentTrip, changeMapZoom);
    });

    document.addEventListener("trip.html.updated", function() {
        display_trip_html(window.tripPlannerCurrentTrip, true);
    });

    document.addEventListener("directionsUpdateNeeded", function() {
        getTripDirections(window.tripPlannerCurrentTrip).then(directions => {
            window.tripPlannerCurrentTrip.directions = directions;
            display_route(window.tripPlannerCurrentTrip);
        }).catch(e => {
            console.error(e);
        })
    });

    document.addEventListener("favoritedCamps.updated", async () => {
        window.favoritedCamps = await get_favoritedCamps(null).catch(e => {console.error(e)});

        const popout:JQuery<HTMLElement> = $("#stopPopout");
        if (popout.is(":visible") && popout.find(".tab-pane#stays").hasClass("active")) {
            const stopID = popout.attr("stopID");
            const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
            if (stopData == null) return;
            const stop = stopData.stop;
            display_potential_stay_pins(stop);
        };
    });
};